"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
require("./Select.scss");
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
var _excluded = ["id", "className", "disabled", "elementLocator", "placeholder", "options", "value", "name", "children", "touched", "isDynamicWidth", "valid", "errorMsg", "autoComplete", "ariaLabel", "label"];
var PADDING = 68;
var CHARACTER_PIXEL = 8;
var Select = function Select(_ref) {
  var _selectedLabel;
  var id = _ref.id,
    className = _ref.className,
    disabled = _ref.disabled,
    elementLocator = _ref.elementLocator,
    placeholder = _ref.placeholder,
    options = _ref.options,
    value = _ref.value,
    name = _ref.name,
    children = _ref.children,
    touched = _ref.touched,
    isDynamicWidth = _ref.isDynamicWidth,
    valid = _ref.valid,
    errorMsg = _ref.errorMsg,
    autoComplete = _ref.autoComplete,
    ariaLabel = _ref.ariaLabel,
    label = _ref.label,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var selectedLabel = '';
  var selectedOptions = options.filter(function (option) {
    return option.value === value;
  });
  if (selectedOptions != null && selectedOptions.length) {
    selectedLabel = selectedOptions[0].label;
  }
  var classes = (0, _classnames.default)({
    'validation-error': touched && !valid,
    selected: touched && valid
  });
  var labelLength = (_selectedLabel = selectedLabel) == null ? void 0 : _selectedLabel.length;
  var dynamicWidth = PADDING + labelLength * CHARACTER_PIXEL + "px";
  var width = _screenSizes.default.isMobile() ? '100%' : dynamicWidth;
  var style = {
    width: isDynamicWidth ? width : '100%'
  };
  var getErrorMsg = function getErrorMsg() {
    return _react.default.createElement(_react.default.Fragment, null, touched && !valid && _react.default.createElement("span", {
      className: "col-sm-12 error-msg",
      "data-locator": elementLocator && elementLocator + "-error" || "input-error-" + name
    }, errorMsg));
  };
  var getOption = function getOption() {
    return _react.default.createElement(_react.default.Fragment, null, placeholder && _react.default.createElement("option", {
      value: ""
    }, placeholder), options.map(function (opt) {
      return _react.default.createElement("option", {
        key: opt.value,
        value: opt.value,
        "aria-label": opt.label
      }, opt.label);
    }));
  };
  return _react.default.createElement("div", {
    className: "select-dropdown-container",
    "data-locator": "select-dropdown-container"
  }, label && _react.default.createElement("label", {
    htmlFor: id
  }, label), _react.default.createElement("select", (0, _extends2.default)({
    id: id,
    name: name,
    className: "select-dropdown " + className + " " + classes,
    style: style,
    value: value,
    disabled: disabled,
    "data-locator": elementLocator || "select-input-" + name + "-" + id,
    "aria-label": ariaLabel,
    autocomplete: autoComplete
  }, others), !(0, _lodash.isEmpty)(children) && children, (0, _lodash.isEmpty)(children) && getOption()), getErrorMsg());
};
Select.defaultProps = {
  disabled: false,
  value: '',
  placeholder: '',
  className: '',
  elementLocator: '',
  options: [],
  children: '',
  isDynamicWidth: false,
  touched: false,
  valid: false,
  errorMsg: '',
  autoComplete: '',
  ariaLabel: '',
  label: ''
};
var _default = Select;
exports.default = _default;
module.exports = exports["default"];